import { XMarkIcon } from '@heroicons/react/16/solid';
import { SignalIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import { BottomNavigation, Button, Divider, Modal } from 'react-daisyui';
import { Trans, useTranslation } from 'react-i18next';
import '../../../../../assets/react.svg';
import { useModalsContext } from '../../../../../providers/ModalsProvider/Modals.context.ts';
import {
  DISCONNECT_ANDROID_VIDEO_POSTER_URL,
  DISCONNECT_ANDROID_VIDEO_URL,
  DISCONNECT_IOS_VIDEO_POSTER_URL,
  DISCONNECT_IOS_VIDEO_URL,
} from './DisconnectionModal.constants.ts';
import './DisconnectionModal.styles.scss';

export default function DisconnectionModal() {
  const { t } = useTranslation('sidebar/sidebarComponent');
  const {
    disconnectionModalIsOpen,
    setDisconnectionModalIsOpen,
    setForceDisconnectionModalIsOpen,
  } = useModalsContext();

  const [isAndroidSelected, setIsAndroidSelected] = useState(true);
  const videoUrl = isAndroidSelected
    ? DISCONNECT_ANDROID_VIDEO_URL
    : DISCONNECT_IOS_VIDEO_URL;
  const posterUrl = isAndroidSelected
    ? DISCONNECT_ANDROID_VIDEO_POSTER_URL
    : DISCONNECT_IOS_VIDEO_POSTER_URL;

  function handleDisconnect() {
    setForceDisconnectionModalIsOpen(true);
    setDisconnectionModalIsOpen(false);
  }

  return (
    <Modal.Legacy
      open={disconnectionModalIsOpen}
      onClickBackdrop={() => {
        setDisconnectionModalIsOpen(false);
      }}
      className="DisconnectionModal"
    >
      <Modal.Header className="DisconnectionModal__Header">
        <XMarkIcon
          onClick={() => {
            setDisconnectionModalIsOpen(false);
          }}
          className="DisconnectionModal__Icon"
        />
      </Modal.Header>
      <Modal.Body className="DisconnectionModal__Body">
        <div className="DisconnectionModal__Status__Text">
          <h1>{t('page.modals.disconnection.title')}</h1>
          <div>
            <SignalIcon className="DisconnectionModal__Icon DisconnectionModal__Icon--success" />
            <span>{t('page.modals.disconnection.connectionStatus')}</span>
          </div>
        </div>
        <div className="DisconnectionModal__Body__Element DisconnectionModal__Body__Element--left">
          <div className="DisconnectionModal__Warning">
            <p className="DisconnectionModal__Warning__Icon">⚠️</p>
            <p className="DisconnectionModal__Warning__Text">
              <Trans
                i18nKey={t('page.modals.disconnection.description')}
                components={[
                  <span className="text-error font-sans font-bold" />,
                  <br />,
                ]}
              />
            </p>
          </div>
          <h2>{t('page.modals.disconnection.subtitle')}</h2>
          <ol>
            <li>{t('page.modals.disconnection.step1')}</li>
            <li>{t('page.modals.disconnection.step2')}</li>
            <li>{t('page.modals.disconnection.step3')}</li>
          </ol>
        </div>

        <div className="DisconnectionModal__Body__Element DisconnectionModal__Body__Element--right">
          <BottomNavigation
            className="DisconnectionModal__Navigation"
            size="xs"
          >
            <BottomNavigation.Item
              active={isAndroidSelected}
              color={isAndroidSelected ? 'primary' : 'neutral'}
              onClick={() => setIsAndroidSelected(true)}
            >
              <p>Android</p>
            </BottomNavigation.Item>
            <BottomNavigation.Item
              active={!isAndroidSelected}
              color={!isAndroidSelected ? 'primary' : 'neutral'}
              onClick={() => {
                setIsAndroidSelected(false);
              }}
            >
              <p>iOS</p>
            </BottomNavigation.Item>
          </BottomNavigation>
          <video src={videoUrl} autoPlay loop muted poster={posterUrl}></video>
        </div>
      </Modal.Body>
      <Divider />
      <p className="text-sm">
        {t('page.modals.disconnection.blockedAccount')}{' '}
        <Button
          onClick={handleDisconnect}
          variant="link"
          size="sm"
          className="text-blue-400"
          tag="a"
        >
          {t('page.modals.disconnection.infoButton')}
        </Button>
      </p>
    </Modal.Legacy>
  );
}
